import { useRef, useState } from 'react';

import { Block } from '@attom';
import { useDidMount } from '@hooks';
import { Price } from '@utils';

import CS from './PrimaryInput.module.scss';

export const PrimaryInput = ({
	//
	children,
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	// element control
	elClass = '',
	elSpace = 'py-8px px-20px',
	color = 'base', // colorsList in (framework && styles)
	//
	value = '',
	placeholder = '',
	label = '',
	isValid = null,
	numeric = null, // numbers only
	priceMode = null, // seprate and numbers
	bankMode = null, // seprate and numbers
	otpMode = null,
	persianMode = null,
	//
	onChange = null,
	disabled = null,
	focus = null,
	required = null,
	readOnly = null,
	maxLength = null,
	onFocus = null,
	onBlur = null,
	...props
}) => {
	//
	const rf = useRef();

	const [isFocus, setFocus] = useState(false);

	const onFocusHandler = (e) => {
		setFocus(true);
		onFocus && onFocus(e);
	};

	const onBlurHandler = (e) => {
		setFocus(false);
		onBlur && onBlur(e);
	};

	useDidMount(() => {
		if (focus) {
			rf.current.focus();
		}
	}, []);

	const changeInput = (e) => {
		if (priceMode) e.target.value = e.target.value.replaceAll(',', '');
		if (bankMode) e.target.value = e.target.value.replaceAll('-', '');
		if ((numeric || priceMode || bankMode || otpMode) && isNaN(e.target.value)) return;
		if (persianMode && !/^[آ-ی\s]{0,}$/.test(e.target.value)) return;
		if (onChange) onChange(e);
	};

	const valueHandler = (priceMode && Price.seperate(value)) || (bankMode && Price.seperateDash(value)) || value;
	const validationClass = (isValid === null && 'pure') || (isValid && 'valid') || 'invalid';
	const modeClass = (otpMode && 'otp') || '';
	const numericClass = ((numeric || priceMode || bankMode || otpMode) && 'y') || 'n';

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace}>
			<div className={CS.container} _color={color} _validation={validationClass} _status={value ? 'fill' : 'void'}>
				<input
					type='text'
					placeholder={isFocus ? placeholder : label}
					onChange={changeInput}
					className={`${CS.input} ${elClass} ${elSpace}`}
					_numeric={numericClass}
					_mode={modeClass}
					disabled={disabled}
					readOnly={readOnly}
					ref={rf}
					onFocus={onFocusHandler}
					onBlur={onBlurHandler}
					value={valueHandler}
					maxLength={otpMode ? 6 : maxLength}
					{...props}
				/>
				{label && <span className={CS.label}>{label}</span>}
				{required && <span className={CS.required}>*</span>}
				<span className={CS.validationIcon} />
				{children}
			</div>
		</Block>
	);
};
